<template>
  <div>
    <v-layout row wrap justify-center>
      <v-flex xs6>
        <v-card class="pa-4">
          <v-text-field
            v-model="user_id"
            label="UserID"
            type="number"
            :error-messages="errors"
          ></v-text-field>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded @click="ask()">Ban Account</v-btn>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card class="pa-4">
        <v-card-title primary-title> Ban Account </v-card-title>

        <v-card-text>
          <div>Do you want to ban this account's device?</div>

          <div>ID: {{ user_id }}</div>
        </v-card-text>

        <v-card-actions>
          <v-progress-circular v-show="loading" :value="20" indeterminate></v-progress-circular>
          <v-spacer></v-spacer>
          <v-btn v-show="!loading" color="gray" rounded outlined @click="dialog = false"
            >Cancel</v-btn
          >
          <v-btn v-show="!loading" color="primary" rounded @click="send()">Ban</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      user_id: 0,
      loading: false,
      errors: [],
    };
  },

  methods: {
    ask() {
      if (this.user_id == 0) {
        this.errors = ['User ID must be bigger than 0!'];
        return;
      }

      this.dialog = true;
    },

    async send() {
      this.loading = true;
      this.errors = [];

      try {
        let res = await axios.post('/admin/users/devices/delete', {
          user_id: this.user_id,
        });
        this.user_id = 0;

        this.$emit('reset', res.data);
      } catch (e) {
        if (e.response && e.response.status == 403) {
          this.errors = [e.response.data];
        }
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
  },
};
</script>
